/**
 * Rimuove i tag HTML da una stringa e restituisce testo semplice.
 * Utilizza il DOM del browser per un parsing sicuro (nessun dangerouslySetInnerHTML).
 * 
 * @param {string} html - Stringa potenzialmente contenente markup HTML
 * @returns {string} - Testo semplice senza tag HTML
 */
export const stripHtmlTags = (html) => {
  if (!html || typeof html !== 'string') return html;
  if (!/<[^>]+>/.test(html)) return html;

  const tmp = document.createElement('div');
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || '';
};
